import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import {
  TProductFloatingMenuApiData,
  TProductFloatingMenuFields,
  TProductFloatingMenuItem,
  TProductFloatingMenuProps,
} from '../types/productFloatingMenu.types';

export class ProductFloatingMenuModel {
  private readonly fields?: TProductFloatingMenuFields;
  private readonly rendering?: ComponentRendering;

  constructor(props: TProductFloatingMenuProps) {
    this.fields = props.fields || undefined;
  }

  get apiData(): TProductFloatingMenuApiData {
    return this.fields?.apiData || {};
  }

  get allFloatingMenuItems(): TProductFloatingMenuItem[] {
    return this.fields?.floatingMenuItems?.items || [];
  }

  getFloatingMenuItemsToLoad(isWide): TProductFloatingMenuItem[] {
    if (isWide) {
      return this.allFloatingMenuItems.filter((_el, index) => index < 7);
    }

    return this.allFloatingMenuItems.filter((el) => el.fields?.isMobile?.value).filter((_el, index) => index < 4);
  }

  get thumbnailEE(): string {
    return this.fields?.itemData?.thumbnail || '';
  }

  get componentName(): string {
    return this.rendering?.componentName || '';
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
